export default __webpack_public_path__ + "static/media/akamai.d06c34f8.svg";